import { Injectable } from '@angular/core';
import { ChargePointLocation, ChargePointType } from './small-biz-store.model';

@Injectable({
  providedIn: 'root',
})
export class ProductSetupMapperService {
  public productCodeToChargePointType(code: string): ChargePointType {
    return codeAsPointType.get(code);
  }

  public chargePointTypeToProductCode(type: ChargePointType): string {
    return pointTypeAsCode.get(type);
  }

  public productCodeToChargePointLocation(code: string): ChargePointLocation {
    return codeAsLocationType.get(code);
  }

  public locationTypeToProductCode(location: ChargePointLocation): string {
    return locationTypeAsCode.get(location);
  }
}

const codeAsPointType = new Map<string, ChargePointType>([
  ['EVC_CHARGING_STATION_TYPE_1_30', ChargePointType.connect30],
  ['EVC_CHARGING_STATION_TYPE_1_50', ChargePointType.connect50],
  ['EVC_CHARGING_STATION_TYPE_2_30', ChargePointType.connect30Pro],
  ['EVC_CHARGING_STATION_TYPE_2_50', ChargePointType.connect50Pro],
]);

const pointTypeAsCode = new Map<ChargePointType, string>([
  [ChargePointType.connect30, 'EVC_CHARGING_STATION_TYPE_1_30'],
  [ChargePointType.connect50, 'EVC_CHARGING_STATION_TYPE_1_50'],
  [ChargePointType.connect30Pro, 'EVC_CHARGING_STATION_TYPE_2_30'],
  [ChargePointType.connect50Pro, 'EVC_CHARGING_STATION_TYPE_2_50'],
]);

const codeAsLocationType = new Map<string, ChargePointLocation>([
  ['EVC_PLACEMENT_INSIDE_WALL_30', ChargePointLocation.wallInside30],
  ['EVC_PLACEMENT_INSIDE_WALL_50', ChargePointLocation.wallInside50],
  ['EVC_PLACEMENT_OUTSIDE_WALL_30', ChargePointLocation.wallOutside30],
  ['EVC_PLACEMENT_OUTSIDE_WALL_50', ChargePointLocation.wallOutside50],
  ['EVC_PLACEMENT_OUTSIDE_POLE_30', ChargePointLocation.poleOutside30],
  ['EVC_PLACEMENT_OUTSIDE_POLE_50', ChargePointLocation.poleOutside50],
]);

const locationTypeAsCode = new Map<ChargePointLocation, string>([
  [ChargePointLocation.wallInside30, 'EVC_PLACEMENT_INSIDE_WALL_30'],
  [ChargePointLocation.wallInside50, 'EVC_PLACEMENT_INSIDE_WALL_50'],
  [ChargePointLocation.wallOutside30, 'EVC_PLACEMENT_OUTSIDE_WALL_30'],
  [ChargePointLocation.wallOutside50, 'EVC_PLACEMENT_OUTSIDE_WALL_50'],
  [ChargePointLocation.poleOutside30, 'EVC_PLACEMENT_OUTSIDE_POLE_30'],
  [ChargePointLocation.poleOutside50, 'EVC_PLACEMENT_OUTSIDE_POLE_50'],
]);
